const portalScroll = (x: number, y: number) => {
  window.document.querySelector('.portal-container-large')?.scrollTo(x, y);
};

export { portalScroll };
